import React from 'react';

class PrivateChatAdminHelperComponent extends React.Component{
	render(){
		if(!this.props.player)
		{
			return null;
		}
		if(!this.props.player.is_mod)
		{
			return null;
		}
		return (
			<div className="private_chat_admin_helper">
				<span>
					Username changes can be made on
					<a href={siteUrl+'/player'} target="_blank">your profile page</a>
				</span>
				<span>
					Upcoming features and recent changes can be seen
					<a href={siteUrl+'/change-log'} target="_blank">here</a>
				</span>
				<span>
					Feature requests, ideas, and suggestions can be submitted
					<a href={siteUrl+'/bugs/submit'} target="_blank">here</a>
				</span>
			</div>
		)

	}
}

export {PrivateChatAdminHelperComponent};
